// Кнопка «← Назад к ИИ» на экранах MES, открытых из /ai (ссылка с ?from=ai).
// Признак держим в sessionStorage: внутри экрана адрес может смениться, а
// кнопка нужна, пока человек не вернулся или не вышел.
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const KEY = 'from_ai';

export default function AiBackBar() {
  const loc = useLocation();
  const navigate = useNavigate();
  const fromAi = new URLSearchParams(loc.search).get('from') === 'ai';

  useEffect(() => {
    try {
      if (fromAi) sessionStorage.setItem(KEY, '1');
      else if (loc.pathname === '/ai' || loc.pathname === '/login') sessionStorage.removeItem(KEY);
    } catch (e) { /* */ }
  }, [fromAi, loc.pathname]);

  let on = fromAi;
  try { on = on || sessionStorage.getItem(KEY) === '1'; } catch (e) { /* */ }
  if (!on || loc.pathname === '/ai' || loc.pathname === '/login') return null;
  return (
    <button
      onClick={() => navigate('/ai')}
      style={{
        position: 'fixed', left: 12, bottom: 12, zIndex: 9999,
        padding: '10px 16px', borderRadius: 24, border: '1px solid var(--border, #ccc)',
        background: 'var(--card, #fff)', color: 'var(--text, #111)', fontSize: 15,
        fontWeight: 700, boxShadow: '0 2px 10px rgba(0,0,0,.25)', cursor: 'pointer',
        fontFamily: 'inherit',
      }}
    >
      ← Назад к ИИ
    </button>
  );
}
